import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import request from '../../lib/requester'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn


class userlist extends Component {


    constructor(props) {
        super(props);
        
        this.state = {
            dataTable: [],
            baseTable: [],
            search: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }
    
    componentDidMount = () => {
        let url = '/arman/v1/user/userlist'
        let param = {
            org_id: this.state.user.org_id
        }
        this.setState({ loading: true })
        request.postArman(url, param, {
            success: function(response) {
                let { data } = response.data
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data})
            }.bind(this),
            error: function(e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    renderTable = () => {
        const data = {
            columns: [
                {
                    Header: 'USER NAME',
                    accessor: 'username'
                },

                {
                    Header: 'ROLE',
                    accessor: 'username'
                },
                {
                    Header: 'Original Branch',
                    accessor: 'username'
                },
                {
                    Header: 'CREATION DATE',
                    accessor: 'creation_date',
					Cell: row => (
						<span>
							<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
							</span>
						</span>
					)
                },
                {
                    Header: 'CREATED BY',
                    accessor: 'username',
			
                },
                {
                    Header: '',
                    accessor: 'user_id',
                    width: 90,
					Cell: row => (
						<span>
                            <button className="btn btn-success btn-sm" onClick={ () => { this.goDetail(row) } }>Update <i className="fas fa-check" /></button>
						</span>
					)
                }
            ],
            rows: this.state.dataTable

        }
        return (<ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
        />)
    }

    handleSearch = (e) => {
    let value = e.target.value
    this.setState({ search: value })
    let baseTable = _.filter(this.state.baseTable, function(o) {
        return o.username.toLowerCase().includes(value.toLowerCase())
    })
    this.setState({ dataTable: baseTable })
    }

    goDetail = (rows) => {
        let { row } = rows
        this.props.history.push('/admin/setup/user/userupdate/' + row.user_id)
    }


    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search User..." onChange={ this.handleSearch.bind(this) } />
                                            </div>
                                        </div>
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                { this.renderTable() }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }



}
export default userlist